// Khung năng lực số của GV — CHỌN LỌC năng lực ĐẶC TRƯNG mỗi miền (ánh xạ đúng việc GV
// làm trên nền tảng để có minh chứng tự động). Dạng dữ liệu MỞ, thêm năng lực khác dễ dàng.
export interface Competency {
  code: string          // vd '1.1', '5.2'
  domain: number        // 1..5
  name: string
  levels: { level: 1 | 2 | 3; descriptors: string[] }[]
}

export const DOMAIN_NAMES: Record<number, string> = {
  1: 'Tổ chức dạy học, giáo dục trong môi trường số',
  2: 'Kiểm tra, đánh giá',
  3: 'Trao quyền cho người học',
  4: 'Kĩ năng công nghệ số',
  5: 'Phát triển chuyên môn',
}
export const LEVEL_LABELS = ['Chưa đánh giá', 'Cơ bản', 'Thành thạo', 'Nâng cao'] as const

export const COMPETENCIES: Competency[] = [
  {
    code: '1.1', domain: 1, name: 'Dạy học và giáo dục trong môi trường số',
    levels: [
      { level: 1, descriptors: [
        'Sử dụng chức năng và công cụ cơ bản của nền tảng quản lí học tập (LMS).',
        'Dùng công cụ hỗ trợ dạy học trực tuyến để cung cấp tài liệu và tổ chức hoạt động dạy học đơn giản.',
      ] },
      { level: 2, descriptors: [
        'Xây dựng kế hoạch bài dạy theo tiếp cận công nghệ.',
        'Thiết kế và triển khai mô hình dạy học kết hợp (blended learning) hiệu quả.',
        'Lựa chọn và áp dụng công cụ, tài nguyên số phù hợp mục tiêu dạy học.',
      ] },
      { level: 3, descriptors: [
        'Sáng tạo, đổi mới mô hình dạy học ứng dụng công nghệ số.',
        'Hướng dẫn đồng nghiệp thiết kế các trải nghiệm học tập số.',
      ] },
    ],
  },
  {
    code: '2.1', domain: 2, name: 'Phương thức đánh giá',
    levels: [
      { level: 1, descriptors: [
        'Dùng hình thức kiểm tra truyền thống, nhập điểm vào hệ thống số.',
        'Áp dụng một số công cụ tạo bài kiểm tra online đơn giản.',
      ] },
      { level: 2, descriptors: [
        'Dùng công cụ số tạo bài kiểm tra, khảo sát cho đánh giá quá trình và tổng kết.',
        'Thiết kế và áp dụng đa dạng hình thức, công cụ đánh giá số phù hợp mục tiêu, nội dung.',
      ] },
      { level: 3, descriptors: [
        'Hướng dẫn đồng nghiệp xây dựng chiến lược đánh giá số hiệu quả, công bằng.',
        'Sáng tạo triển khai mô hình đánh giá số tiên tiến, đánh giá năng lực phức hợp.',
      ] },
    ],
  },
  {
    code: '3.3', domain: 3, name: 'Khuyến khích sự tham gia tích cực của người học',
    levels: [
      { level: 1, descriptors: [
        'Dùng công cụ tương tác số đơn giản để thu hút người học tham gia hoạt động.',
        'Tích hợp công nghệ số để trực quan hóa, tăng hiệu quả trình bày nội dung.',
      ] },
      { level: 2, descriptors: [
        'Tích hợp trò chơi hóa, tương tác và công cụ sáng tạo nội dung để thúc đẩy người học chủ động.',
        'Thiết kế hoạt động khuyến khích người học tự tạo nội dung số, dùng mô phỏng/thí nghiệm ảo.',
      ] },
      { level: 3, descriptors: [
        'Sáng tạo, điều phối dự án học tập dùng công nghệ số, lấy người học làm trung tâm.',
        'Hướng dẫn đồng nghiệp triển khai hoạt động học tập tích cực bằng công nghệ số.',
      ] },
    ],
  },
  {
    code: '4.2', domain: 4, name: 'Sáng tạo nội dung số',
    levels: [
      { level: 1, descriptors: [
        'Tích hợp các định dạng số vào nội dung nhiệm vụ của người học.',
        'Dùng công cụ số phổ biến để tạo nội dung dạy học ở các định dạng khác nhau.',
      ] },
      { level: 2, descriptors: [
        'Tích hợp công nghệ số trong sáng tạo nội dung, xây dựng kho học liệu số.',
        'Hướng dẫn người học tạo nội dung số, thực hiện bản quyền, trích dẫn, chia sẻ hợp pháp.',
      ] },
      { level: 3, descriptors: [
        'Dùng thành thạo công cụ chuyên dụng tạo học liệu số có tính tương tác cao.',
        'Hướng dẫn đồng nghiệp phát triển nền tảng tích hợp AI, thực tế ảo/tăng cường trong sáng tạo nội dung.',
      ] },
    ],
  },
  {
    code: '5.1', domain: 5, name: 'Giao tiếp trong tổ chức',
    levels: [
      { level: 1, descriptors: [
        'Sử dụng email, nhóm chat của trường/tổ để trao đổi thông tin công việc và giao tiếp với phụ huynh.',
        'Sử dụng công cụ số cơ bản để giao tiếp, chia sẻ thông tin, dữ liệu.',
      ] },
      { level: 2, descriptors: [
        'Sử dụng hiệu quả các kênh giao tiếp số chính thức của trường/tổ, phù hợp từng đối tượng và mục đích.',
        'Xây dựng và quản lí chiến lược truyền thông số, kênh truyền thông chính thức để chia sẻ và kết nối cộng đồng.',
      ] },
      { level: 3, descriptors: [
        'Cập nhật xu hướng công nghệ và giao tiếp trong tổ chức bằng công nghệ số.',
        'Tăng tính minh bạch và sự tham gia của các bên liên quan qua kênh giao tiếp số.',
      ] },
    ],
  },
  {
    code: '5.2', domain: 5, name: 'Hợp tác phát triển chuyên môn',
    levels: [
      { level: 1, descriptors: [
        'Chủ động tham gia các cộng đồng học tập trực tuyến.',
        'Tự đánh giá khó khăn, thách thức và thuận lợi khi ứng dụng công nghệ số trong công việc.',
        'Tìm kiếm và tham gia khóa học cơ bản để cập nhật kiến thức, kĩ năng số.',
      ] },
      { level: 2, descriptors: [
        'Tham gia hoạt động chuyên môn với đồng nghiệp bằng các công cụ số.',
        'Xây dựng kế hoạch cải tiến, đổi mới ứng dụng công nghệ số trong hoạt động giáo dục chuyên môn.',
        'Tự đánh giá, cải tiến ứng dụng công nghệ số trong dạy học trong môi trường số.',
        'Chia sẻ, học tập và cập nhật kĩ năng ứng dụng công nghệ số với đồng nghiệp.',
      ] },
      { level: 3, descriptors: [
        'Hướng dẫn đồng nghiệp đổi mới cách thức, phương pháp sư phạm số mới và áp dụng vào thực tiễn dạy học.',
        'Hướng dẫn đồng nghiệp xây dựng yêu cầu dạy học trong môi trường số.',
        'Phát triển công cụ, phương pháp hỗ trợ tự phản ánh về năng lực số.',
      ] },
    ],
  },
  {
    code: '5.3', domain: 5, name: 'Phát triển, sử dụng, chia sẻ và quản lí học liệu số',
    levels: [
      { level: 1, descriptors: [
        'Sử dụng công cụ tìm kiếm phổ biến để tìm tài nguyên, kho học liệu số, thư viện trực tuyến, OER.',
        'Lựa chọn tài nguyên phù hợp với mục tiêu bài học.',
      ] },
      { level: 2, descriptors: [
        'Lựa chọn và sử dụng tài nguyên, học liệu số phù hợp với đối tượng đa dạng của người học.',
        'Tạo tài nguyên số phục vụ môn học từ các nguồn có sẵn.',
        'Đánh giá chất lượng, độ tin cậy, tính pháp lí và sư phạm của tài nguyên, học liệu số.',
        'Tổ chức lưu trữ, quản lí và chia sẻ kho học liệu số cá nhân một cách khoa học, an toàn.',
      ] },
      { level: 3, descriptors: [
        'Hướng dẫn đồng nghiệp xây dựng và quản trị kho học liệu số mở của tổ/trường.',
        'Xây dựng và quản trị hệ thống quản lí, chia sẻ tài nguyên số cho nhà trường.',
      ] },
    ],
  },
]
